import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

export const POINTER_EVENTS_NONE_CLASS = 'pe-none';
@Component({
  selector: 'app-tooltip-icon',
  templateUrl: './tooltip-icon.component.html',
  styleUrls: ['./tooltip-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TooltipIconComponent implements OnInit {
  @Input() matIconName?: string;
  @Input() matIconTheme?: 'material-icons-outlined' | 'material-icons-sharp';
  @Input() svgIconName?: string;
  @Input() placement?:
    | 'top'
    | 'top-left'
    | 'top-right'
    | 'bottom'
    | 'bottom-left'
    | 'bottom-right'
    | 'left'
    | 'left-top'
    | 'left-bottom'
    | 'right'
    | 'right-top'
    | 'right-bottom';
  @Input() size?: '16' | '24';
  @Input() tooltipContent: string;
  @Input() handleEvents = false;
  @Input() closeOnScroll?: boolean;
  @Input() noDealerPriceIcon?: boolean;
  @Input() noPointerEventsOnElement?: string;
  @Input() dealerPriceIconContainerClass?: string;
  @Input() uniqueClass?: string;

  isMobile = this.deviceDetectorService.isMobile();
  isTablet = this.deviceDetectorService.isTablet();
  isDesktop = this.deviceDetectorService.isDesktop();

  targetElement: HTMLElement;

  constructor(private languageService: ShimanoLanguageService, private deviceDetectorService: DeviceDetectorService) {}

  ngOnInit() {}

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  get isActiveTooltipIconHasUnique(): boolean {
    const activeTargetElement = document.querySelector(`popover-container.tooltip-icon`);
    return activeTargetElement && activeTargetElement.classList.contains(`code-${this.uniqueClass}`);
  }

  get isTooltipIconOpen(): boolean {
    return document.querySelector(`popover-container.tooltip-icon`) !== null;
  }

  onClickTooltipIcon(event: any) {
    if (this.handleEvents && (!this.isActiveTooltipIconHasUnique || this.isTooltipIconOpen)) {
      this.targetElement = event.target.closest(this.noPointerEventsOnElement);
      this.togglePointerEvents(this.targetElement, true);
    }
  }

  emitEvents(event?: any) {
    if (this.handleEvents && !this.isDesktop) {
      this.togglePointerEvents(this.targetElement, false);
    }
  }

  togglePointerEvents(element: HTMLElement, add: boolean) {
    if (element) {
      add ? element.classList.add(POINTER_EVENTS_NONE_CLASS) : element.classList.remove(POINTER_EVENTS_NONE_CLASS);
    }
  }
}
